import styled from 'styled-components';
import { spacing1x, spacing2x } from '../../styles/spacing.js';
import { jsx } from 'react/jsx-runtime';

var ThumbnailContainer = styled.div.withConfig({
  displayName: "EntityThumbnail__ThumbnailContainer",
  componentId: "sc-17ecahf-0"
})(["&&{background-color:", ";background-image:url(", ");background-position-x:center;background-position-y:center;background-repeat:no-repeat;background-size:contain;border-radius:", ";flex-shrink:0;height:42px;margin-inline-end:", ";width:74px;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.neutralColors.pearl;
}, function (_ref2) {
  var url = _ref2.url;
  return url;
}, spacing1x, spacing2x);
var EntityThumbnail = function EntityThumbnail(props) {
  var url = props.url;
  return /*#__PURE__*/jsx(ThumbnailContainer, {
    url: url
  });
};
EntityThumbnail.displayName = "EntityThumbnail";

export { EntityThumbnail };
